import { Data } from './data';
import { Img } from './img';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Config } from '../../config/config';

export class Publication extends Data {

    photo: Img;
    titre: string;
    description: string;
    slug: string;
    is_publish: boolean;
    date_publish: any;
    video_youtube;

    constructor() {

        super();
        this.date_publish = ( new Date()).toISOString().split('T')[0];
        
    }

    
    
    get converDatePublishToNgbDateStruct(): any {
      if (this.date_publish !== null && this.date_publish !== undefined) {
        const tab = this.date_publish.split(' ');
        const tab2 = tab[0].split('-');
        return {
          year: Number( tab2[0]),
          month: Number( tab2[1]),
          day: Number( tab2[2]),
        };
      } else {
        return null;
      }
    
    }

    get urltmbPhoto(): string {

        if( this.photo !== undefined && this.photo !== null && this.photo.url !== null)
        return  Config.urlserveur + this.photo.url; // return  Config.urlserveur + this.photo.tmb;
        else
        return 'assets/images/noimage.png';
    }

    deletePhoto() {

      this.photo = null;
    }

    generateSlug(str: string): string {

        const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
        const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
        const p = new RegExp(a.split('').join('|'), 'g')
    
        return  str.toString()
                        .toLowerCase()
                        .replace(/\s+/g, '-') // Replace spaces with -
                        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
                        .replace(/&/g, '-and-') // Replace & with 'and'
                        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
                        .replace(/\-\-+/g, '-') // Replace multiple - with single -
                        .replace(/^-+/, '') // Trim - from start of text
                        .replace(/-+$/, '') // Trim - from end of text
    
    }
    
    /* converStringToDatetime(date: string): any {
    
      if (date !== undefined && date !== '' && date !== null) {
    
          const tabDate = date.split(' ');
          const tab = tabDate[0].split('-');
    
          if (tabDate[1] === undefined) {
    
            return {
              date: {
                year: Number(tab[0]),
                month: Number(tab[1]),
                day: Number(tab[2]),
              },
              time: {
                hour: 0,
                minute: 0,
              },
            };
    
          } else {
    
            const tabtime = tabDate[1].split(':');
    
            return {
              date: {
                year: Number(tab[0]),
                month: Number(tab[1]),
                day: Number(tab[2]),
              },
              time: {
                hour: Number(tabtime[0]),
                minute: Number(tabtime[1]),
              },
            };
    
          }
    
          // const tab = date.split('-');
    
      } else {
          return null;
      }
    
    
    } */
}